import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const StyledTypography = styled.div<any>`
  background-color: ${(props) =>
    props.backgroundColor
      ? props.theme.colors[props.backgroundColor]
      : "transparent"};
  color: ${(props) => props.theme.colors[props.color || "black"]};
  font-weight: ${(props) => props?.weight};
  ${({ size, lineHeight }) => css`
    ${size && `font-size: ${size}px;`}
    ${lineHeight && `line-height: ${lineHeight}px;`}
  `}
  text-align: ${(props) => props.align || "left"};
  ${(props) => props.styleText}
`;
